import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { DelegateService } from 'src/app/services/delegate.service';
import { Global } from 'src/app/Global';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { CommonService } from 'src/app/services/common.service';
import { AlertService } from 'src/app/common/alert.service';
import { SelectionModel } from '@angular/cdk/collections';
// import saveAs from 'file-saver';

@Component({
    selector: 'app-view-delegate',
    templateUrl: './view-delegate.component.html',
    styleUrls: ['./view-delegate.component.css']
})
export class ViewDelegateComponent implements OnInit {

    /***********************************Declare Private Properties************************/
    DelegateRecordsForm: FormGroup;
    isLoadingResults = false;
    displayedColumns = ['Select', 'DelegateName', 'UserGPN'];
    DelegateDataSource: MatTableDataSource<any[]>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    selection = new SelectionModel<any>(true, []);
    delegateList: any;
    filterList: any;
    /******************************************END***************************************/

    constructor(private _fb: FormBuilder, private _router: Router, public _global: Global,
        public _commonService: CommonService, private error: AppErrorHandler,
        private _delegateService: DelegateService, injector: Injector, public _alertService: AlertService,
        private status: HTTPStatus) { }

    ngOnInit() {
        this.DelegateRecordsForm = this._fb.group({
            DelegateName: [],
            EmployeeName: [],
            DelegationID: [],
            UserGPN: []
        });
        this.SearchRecord();
    }

    SearchRecord() {
        this._global.length = 0;
        this.LoadAllDelegationList();
    }

    LoadAllDelegationList() {
        this.status.setHttpStatus(true);
        if (this._global.pageIndex === 0) {
            this._global.pageIndex = 1;
        }
        this._delegateService.GetAllDelegationMasterList(this.DelegateRecordsForm.value).subscribe(data => {
            if (data != null) {
                this.DelegateDataSource = new MatTableDataSource(data);
                this._global.length = data.TotalRecordCount;
                if (this._global.length === 0) {
                    this.DelegateDataSource = null;
                } else {
                    this.status.setHttpStatus(false);
                }
            } else {
                this.DelegateDataSource = new MatTableDataSource(data);
                this._global.length = data.TotalRecordCount;
            }
            this.GetDelegationList();
        }, (error) => {
            this.status.setHttpStatus(false);
            this.error.handleError(error);
        }, () => { this.status.setHttpStatus(false); });
    }

    ShowDetails(row: any) {
        this._router.navigate(['home/add-delegate', row.DelegateId]);
    }

    Reset() {
        this.DelegateRecordsForm.reset();
    }


    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = !!this.DelegateDataSource && this.DelegateDataSource.data.length;
        return numSelected === numRows;
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ? this.selection.clear() : this.DelegateDataSource.data.forEach(r => this.selection.select(r));
    }
    /** The label for the checkbox on the passed row */
    checkboxLabel(row: any): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.DelegateId + 1}`;
    }

    DeleteRecord() {
        const numSelected = this.selection.selected;
        if (numSelected.length > 0) {
            if (confirm("Are you sure you want to delete this record?")) {
                this._delegateService.DeleteDelegate(numSelected).subscribe(result => {
                    this._alertService.notify('success', 'Success!', 'Delegate deleted successfully');
                    this.SearchRecord();
                })
            }
        } else {
            alert("Select at least one row");
        }
    }

    GetDelegationList() {
        this._delegateService.GetDelegationList().subscribe(result => {
            this.delegateList = result;
        }, (error) => {
            this.status.setHttpStatus(false);
            this.error.handleError(error);
        }, () => { this.status.setHttpStatus(false); });
    }
}


